"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./FieldRadio.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FieldRadio extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onBlur", event => {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    });

    _defineProperty(this, "onFocus", event => {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    });

    _defineProperty(this, "onChange", event => {
      let value;

      if (event.target.checked) {
        value = this.props.value || true;
      } else {
        value = false;
      }

      if (this.props.onChange) {
        this.props.onChange(value, event);
      }
    });
  }

  render() {
    const _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          checked = _this$props.checked,
          value = _this$props.value,
          required = _this$props.required,
          disabled = _this$props.disabled,
          readonly = _this$props.readonly,
          autofocus = _this$props.autofocus;
    const label = this.props.title || this.props.label || "radio";
    return _react.default.createElement("label", {
      className: "admin-field  field--radio"
    }, _react.default.createElement("input", {
      type: "radio",
      id: id,
      name: name,
      checked: checked,
      value: value,
      required: required,
      disabled: disabled || readonly,
      autoFocus: autofocus,
      onChange: event => this.onChange(event),
      onBlur: event => this.onBlur(event),
      onFocus: event => this.onFocus(event)
    }), _react.default.createElement("i", {
      className: "radio__icon"
    }), _react.default.createElement("b", {
      className: "radio__label"
    }, label));
  }

}

_defineProperty(FieldRadio, "defaultProps", {
  value: "",
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false
});

var _default = FieldRadio;
exports.default = _default;
module.exports = exports.default;